import MiniQ2TableTypeS from "./MiniQ2TableTypeS";
import MiniQ2TableTypeM from "./MiniQ2TableTypeM";
const MiniQ2Table = ({item, t}) => {
    const TYPES = {
        "s": t("standalone"),
        "m": t("multiple"),
    }
    return <>
        <div className="d-inline-block text-center ps-2 pe-3 border-end">
            <div className="fw-medium">{t("type")}</div>
            <div>{TYPES[item.type]}</div>
        </div>
        {
            item.type === "s"
                ? <MiniQ2TableTypeS item={item} t={t}/>
                : <MiniQ2TableTypeM item={item} t={t}/>
        }


    </>
}
export default MiniQ2Table